import Button from "./Button";
import Heading from "./Heading";
import Question from "./Question";

export default function Stage({ heading, onClick, question, stage }) {
    return (
        <div className="test__stage">
            <Heading>
                {heading}
            </Heading>

            <Question>{question}</Question>

            <div className="test__buttons">
                <div className="test__button-col">
                    <Button label="Agree" onClick={onClick} stage={stage} />
                </div>
                <div className="test__button-col">
                    <Button label="Disagree" onClick={onClick} stage={stage} />
                </div>
            </div>
        </div>
    )
}